import { useSelector } from 'react-redux';
import { useActions } from 'utils/hooks';
import { NavLink } from 'react-router-dom';
import * as sidebarActions from 'store/sidebar/actions';
import arrow from 'assets/svg/common/arrow.svg';
import SvgRender from 'common/components/general/SvgRender';

const isLinkActiveCustomLogic = (location, item, account, sub) => {
  if (sub) {
    return location.pathname.includes(item.label);
  } else {
    if (location.pathname === '/') {
      return item.path === location.pathname;
    } else if (
      item.path !== '/' &&
      (location.pathname === item.path || location.pathname.startsWith(`${item.path}/`))
    ) {
      return true;
    } else return false;
  }
};

const MenuItem = ({ item, setActive, active, setIsSubmenuOpen }) => {
  const [togglePanel] = useActions([sidebarActions.togglePanel]);
  const account = useSelector(state => state.account);

  return (
    <div className="menu-item">
      <div className="menu-item--nav">
        <NavLink
          to={{ pathname: item.path, search: '' }}
          exact={true}
          isActive={(match, location) =>
            isLinkActiveCustomLogic(location, item, account, item.submenu && !item.hiddenSubmenu)
          }
          onClick={() => {
            if (active ? active.label !== item.label : true) setActive(item);
            if (item.submenu && !item.hiddenSubmenu) setIsSubmenuOpen(true);
            else togglePanel(null);
          }}
        >
          {item.icon && <SvgRender style={{ height: 18, width: 18 }} src={item.icon} />}
          <span className={item.icon ? 'ms-2' : ''}>{item.name}</span>
          {item.submenu && !item.hiddenSubmenu && (
            <SvgRender
              className="menu-item--nav-submenu-arrow"
              src={arrow}
              style={{ width: 10, height: 10, transform: 'rotate(-90deg)' }}
            />
          )}
        </NavLink>
      </div>
    </div>
  );
};

export default MenuItem;
